"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _makeDecoratorDisplayName = _interopRequireDefault(require("reference-resolvers/lib/makeDecoratorDisplayName"));

var _atom = require("atom");

var _immutable = require("immutable");

var _map = _interopRequireDefault(require("transmute/map"));

var _curry = _interopRequireDefault(require("transmute/curry"));

var _identity = _interopRequireDefault(require("transmute/identity"));

var _memoize = _interopRequireDefault(require("transmute/memoize"));

var _ReferenceResolversContext = _interopRequireWildcard(require("./ReferenceResolversContext"));

var _withReferenceResolverContext = _interopRequireDefault(require("./withReferenceResolverContext"));

// The default merge will favor the higher level cached resolvers.
var defaultMergeResolvers = (0, _memoize.default)(function (providedResolvers, connectedResolvers) {
  return (0, _extends2.default)({}, providedResolvers, connectedResolvers);
});

var getMergeResolversFn = function getMergeResolversFn(mergeResolvers) {
  return mergeResolvers instanceof Function ? mergeResolvers : mergeResolvers === true ? defaultMergeResolvers : _identity.default;
};

var ProvideReferenceResolvers = function ProvideReferenceResolvers(resolvers, Component) {
  var opts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var mergeResolvers = opts.mergeResolvers;

  var ReferenceResolversProvider =
  /*#__PURE__*/
  function (_React$Component) {
    (0, _inherits2.default)(ReferenceResolversProvider, _React$Component);

    function ReferenceResolversProvider() {
      var _this;

      (0, _classCallCheck2.default)(this, ReferenceResolversProvider);
      _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(ReferenceResolversProvider).call(this));
      _this.getCacheAtom = _this.getCacheAtom.bind((0, _assertThisInitialized2.default)(_this));
      _this._cacheAtoms = (0, _immutable.Map)();
      _this.providedResolvers = (0, _map.default)(function (resolver) {
        if (resolver instanceof Function) {
          return resolver(_this.getCacheAtom);
        }

        return resolver;
      }, resolvers);
      _this.mergeResolvers = getMergeResolversFn(mergeResolvers);
      return _this;
    }

    (0, _createClass2.default)(ReferenceResolversProvider, [{
      key: "getCacheAtom",
      value: function getCacheAtom(id) {
        if (!this._cacheAtoms.has(id)) {
          this._cacheAtoms = this._cacheAtoms.set(id, (0, _atom.makeAtom)());
        }

        return this._cacheAtoms.get(id);
      }
    }, {
      key: "render",
      value: function render() {
        var _this$props = this.props,
            forwardedRef = _this$props.forwardedRef,
            connectedResolvers = _this$props.referenceResolverContext,
            rest = (0, _objectWithoutProperties2.default)(_this$props, ["forwardedRef", "referenceResolverContext"]);
        var resolvers = this.mergeResolvers(this.providedResolvers, connectedResolvers, rest);
        return _react.default.createElement(_ReferenceResolversContext.default.Provider, {
          value: resolvers
        }, _react.default.createElement(Component, (0, _extends2.default)({
          ref: forwardedRef
        }, rest)));
      }
    }]);
    return ReferenceResolversProvider;
  }(_react.default.Component);

  ReferenceResolversProvider.propTypes = (0, _extends2.default)({}, _ReferenceResolversContext.referenceResolverContextPropTypes, {
    forwardedRef: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.shape({
      current: _propTypes.default.object
    })])
  });
  var ContextConnector = (0, _withReferenceResolverContext.default)(ReferenceResolversProvider);
  ContextConnector.displayName = (0, _makeDecoratorDisplayName.default)('ProvideReferenceResolvers', Component);
  ContextConnector.WrappedComponent = Component;

  if (opts.forwardRef) {
    var ForwardedRef = (0, _react.forwardRef)(function (props, ref) {
      return _react.default.createElement(ContextConnector, (0, _extends2.default)({}, props, {
        forwardedRef: ref
      }));
    });
    ForwardedRef.WrappedComponent = ContextConnector.WrappedComponent;
    return ForwardedRef;
  }

  return ContextConnector;
};

var _default = (0, _curry.default)(ProvideReferenceResolvers);

exports.default = _default;
module.exports = exports.default;